/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_ClassesInputs */

const en_for_whom_tag_classes = /** @type {(inputs: For_Whom_Tag_ClassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group classes`)
};

const pl_for_whom_tag_classes = /** @type {(inputs: For_Whom_Tag_ClassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia grupowe`)
};

/**
* | output |
* | --- |
* | "Group classes" |
*
* @param {For_Whom_Tag_ClassesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_classes = /** @type {((inputs?: For_Whom_Tag_ClassesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_ClassesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_classes(inputs)
	return en_for_whom_tag_classes(inputs)
});